import type { InterventionDetail } from "./intervention.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetIntervention = (
  interventionId?: number | string,
  options?: UseGetOptions<InterventionDetail>
) => {
  const { data, ...queryResult } = useGet<InterventionDetail>(
    "interventions",
    interventionId,
    options
  );

  return {
    intervention: data,
    ...queryResult,
  };
};
